export enum WorkspacesDataEventObject {
  TASKS_FOLDER = 'tasks_folder',
  ROUTINES_FOLDER = 'routines_folder',
  NEW_CONVERSATION_DROPDOWN_TASK = 'new_conversation_dropdown_task',
  NEW_MESSAGE = 'new_message',
}
